import { render, staticRenderFns } from "./NewFine.vue?vue&type=template&id=664358d4"
import script from "./NewFine.vue?vue&type=script&lang=js"
export * from "./NewFine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports